/**
 * docs/decisions/2026-10-28-tpv-sin-conexion.md · the Panel's one service worker, `/panel-sw.js` with scope `/`
 * (`src/service-worker/panel-sw.ts`): the app shell that opens without a connection, and El Parte's web push. A
 * production build registers it at boot; El Parte's push subscribes through the same registration. What every TPV asks
 * of it is `screens/tpv/offline/shell.ts`.
 */

/** The worker's path. */
export const PANEL_SERVICE_WORKER_URL = '/panel-sw.js';
export const PANEL_SERVICE_WORKER_SCOPE = '/';

/** The browser surface the module needs, injectable for the specs. */
export type PanelServiceWorkerEnvironment = Readonly<{
  serviceWorker: Pick<ServiceWorkerContainer, 'register' | 'ready'> | null;
  production: boolean;
}>;

export const browserServiceWorkerEnvironment = (): PanelServiceWorkerEnvironment => ({
  serviceWorker: typeof navigator !== 'undefined' && 'serviceWorker' in navigator ? navigator.serviceWorker : null,
  production: import.meta.env.PROD,
});

/**
 * Registers the worker in a production build; the development server has no built worker. Null when it was not
 * registered (development, no service worker in this browser, or the browser refused it): the Panel works as before.
 */
export async function registerPanelServiceWorker(environment = browserServiceWorkerEnvironment()): Promise<ServiceWorkerRegistration | null> {
  if (!environment.production || environment.serviceWorker === null) return null;
  try {
    return await environment.serviceWorker.register(PANEL_SERVICE_WORKER_URL, { scope: PANEL_SERVICE_WORKER_SCOPE });
  } catch {
    return null;
  }
}
